import { render, staticRenderFns } from "./Study.vue?vue&type=template&id=ddb1ec74&scoped=true"
import script from "./Study.vue?vue&type=script&lang=js"
export * from "./Study.vue?vue&type=script&lang=js"
import style0 from "./Study.vue?vue&type=style&index=0&id=ddb1ec74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb1ec74",
  null
  
)

export default component.exports